import {getCity, validatePersonId} from 'api';
import {createContext} from 'react';
import messages from '@super-template/messages';
import {FormattedMessage, useIntl} from 'react-intl';
import {InputAdornment} from '@material-ui/core';

export const surveyArr = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export const objectives = [
  {key: "1", val: messages.option1},
  {key: "2", val: messages.option2},
  {key: "3", val: messages.option3},
  {key: "4", val: messages.option4},
  {key: "5", val: messages.option5},
  {key: "0", val: messages.option6}];

export const situations = [
  {key: "1", val: messages.option7},
  {key: "2", val: messages.option8},
  {key: "3", val: messages.option9},
  {key: "4", val: messages.option10},
  {key: "5", val: messages.option11}];

export const Break = () => <div style={{clear: 'both'}}/>;

export const getPhone = (value) => value.replace(/[()\-\s]/gm, "");

export const validatePhone = (value, required) => {
  const trimmedValue = getPhone(value);
  const onlyNumbers = /^\d{6,15}$/;
  if (!required && !trimmedValue) return true;
  if (trimmedValue.startsWith("+")) {
    return trimmedValue.startsWith('+358') && onlyNumbers.test(trimmedValue.replace("+", ""));
  } else {
    return onlyNumbers.test(trimmedValue);
  }
};

export const validateEmail = (value = "", id, {clearErrors, setValue}) => {
  const trimmedValue = value.trim();
  const emailRegex = /\S+@\S+\.\S+/;
  if (trimmedValue && !emailRegex.test(trimmedValue)) return false;
  else {
    clearErrors(id);
    setValue(id, trimmedValue);
  }
};

export const validateSsn = (value, id, {setValue, clearErrors}) => {
  const trimmedValue = value.trim();
  if (!trimmedValue) return false;
  else if (trimmedValue.length === 11) {
    return validatePersonId(trimmedValue.toUpperCase()).then(({valid}) => {
      if (valid) {
        setValue(id, trimmedValue.toUpperCase());
        clearErrors(id);
      }
      return valid;
    });
  } else return false;
};

export const setZip = (id, value, cityId, {setValue, setError, clearErrors}) => {
  const trimmedValue = value.trim();
  if (!trimmedValue) setError(id, {type: 'required'});
  else if (trimmedValue.length === 5) {
    getCity(trimmedValue).then(({success, data}) => {
      if (success) {
        clearErrors(id);
        setValue(cityId, data.city);
      } else if (data !== 'networkError') setError(id, {type: 'zip_invalid'});
    });
  } else setError(id, {type: 'zip_length'});
};

export const getProps = (label, step = 1, translate) => ({
  inputProps: {min: 0, step},
  endAdornment: (
    <InputAdornment position="end">
      {translate ? <FormattedMessage {...label} /> : label}
    </InputAdornment>
  ),
});
export const hideAdditional = (h) => h.hideOtherPayerUsed && h.hideWhereInfo && h.hideBMI && h.hideObjectiveQuery && h.hideSituationQuery;

export const hasSpouse = (val) => {
  return !['SINGLE', 'DIVORCED', 'WIDOW', 'JUDICIAL_SEPARATION', 'SINGLE_OR_CO_PARENT'].includes(val);
};

export const yesNo = (not, id) => [
  {label: messages[id ? id + "_true" : "true"], value: 'true'},
  {label: messages[id ? (id + (not ? "_not" : "_false")) : (not ? "not" : "false")], value: 'false'}
];

export const useUnionTranslator = (unions) => {
  const intl = useIntl();
  if (unions) {
    const index = unions.findIndex(item => item.value === 'En kuulu liittoon');
    unions[index] = intl.formatMessage(messages.no_union);
    unions.sort((a, b) =>
      a === 'En kuulu liittoon' ? -1 : a.localeCompare(b)
    );
  }
  return unions;
};

export const SettingsContext = createContext({});
